define('shared/initializer/form/adapters/mixins/upsell/Submittable',[
    '$',
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/util/state/adapters/persistent',
], 
function (
    $,
    RSVP,
    state,
    persistentAdapter
) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doSubmit = function() {
        var me = this;

        if (!me.selectedOffers) {
            return RSVP.resolve();
        }

        return RSVP.resolve()
            .then(function(){
                return state.adapters.add(persistentAdapter);
            })
            .then(function(){
                return state.push('persistent.upsell', {
                    value: {
                        total: me.viewModel.total,
                        url: location.href,
                        selectedOffers: me.selectedOffers
                    }
                });
            });
    };

    return Ctor;
});
